export default __webpack_public_path__ + "static/media/68_mobile.cba7d280.jpg";